// extracted by mini-css-extract-plugin
module.exports = {"HighlightedImage":"HighlightedImage_HighlightedImage__4xYgL"};